import to from "await-to-js";
import { t } from "i18next";
import { useContext, useMemo, useState } from "react";

import { Flex } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Modal } from "../../../../../components/Modal/Modal";
import { ModalsContext } from "../../../../../context/modals.context";
import { MinistryContext } from "../../../../../modules/ministry/ministry.context";
import { ministryService } from "../../../../../modules/ministry/ministry.service";
import { toastService } from "../../../../../utils/toast.service";
import style from "./ReasonModal.module.scss";

export const ReasonModal = () => {
  const { isModalVisible, clearModals, modals, setError } =
    useContext(ModalsContext);
  const { setMinistry } = useContext(MinistryContext);
  const [note, setNote] = useState<string | null>(null);

  const type = modals.type;
  const section = modals.section;
  const statusZahteva = modals.statusZahteva;
  const dozvolaZahtevId = modals.dozvolaZahtevId;
  const markicaZahtevId = modals.markicaZahtevId;

  const handleCancel = () => {
    clearModals();
  };

  const handleApi = () => {
    if (section === "stamps") {
      const postMfObradiZahtevZaMarkicu = async () => {
        const [err, res] = await to(
          ministryService.postMfObradiZahtevZaMarkicu({
            id: markicaZahtevId,
            statusZahteva: statusZahteva,
            markicaZahtevNote: note as any,
          })
        );
        if (err || !res.success) return setError(res?.errorMessage);
        if (statusZahteva === 8) return toastService.success("TOAST.ODBACEN");
        if (statusZahteva === 7)
          return toastService.success("TOAST.VRACEN_NA_DOPUNU");
        return setMinistry({
          updatedZahtevStatusId: res.data,
        });
      };
      postMfObradiZahtevZaMarkicu();
      setTimeout(() => window.location.reload(), 300);
    } else {
      const postMfObradiZahtevZaDozvolu = async () => {
        const [err, res] = await to(
          ministryService.postMfObradiZahtevZaDozvolu({
            id: dozvolaZahtevId,
            statusZahteva: statusZahteva,
            dozvolaZahtevNote: note,
          })
        );
        if (err || !res.success) return setError(res?.errorMessage);
        if (statusZahteva === 5)
          return toastService.success("TOAST.ODBIJ_DOZVOLE");
        if (statusZahteva === 4)
          return toastService.success("TOAST.ODBACEN_DOZVOLE");
        if (statusZahteva === 3)
          return toastService.success("TOAST.VRACEN_NA_DOPUNU_DOZVOLE");
        setMinistry({
          mfObradiZahtevZaDozvoluId: res.data,
        });
      };
      postMfObradiZahtevZaDozvolu();
      setTimeout(() => window.location.reload(), 300);
    }
  };

  const handleOk = () => {
    handleApi();
    clearModals();
    setNote(null);
  };

  const handleReason = (event: any) => {
    setNote(event?.target.value);
  };

  const handleTitle = () => {
    if (type === "odbij") return t("COMMON.ODBIJANJE_ZAHTEVA");
    if (type === "odbaci") return t("COMMON.ODBACIVANJE_ZAHTEVA");
    if (type === "vrati") return t("COMMON.VRACANJE_ZAHTEVA_NA_DOPUNU");
  };

  const maxLength = useMemo(() => {
    return type === "vrati" ? 220 : Infinity;
  }, [type]);

  const lengthReachedMaximum = useMemo(() => {
    return note && maxLength && note?.length === maxLength;
  }, [note, maxLength]);

  return (
    <Modal
      name="razlozi-modal"
      title={handleTitle()}
      onOk={handleOk}
      cancelText={t("COMMON.NAZAD")}
      cancelButtonProps={{ type: "default" }}
      okText={t("AKCIZNE_MARKICE.POSALJI_ZAHTEV")}
      onCancel={handleCancel}
      open={isModalVisible("reason")}
    >
      <Flex vertical gap={8}>
        <TextArea
          value={note as any}
          onChange={handleReason}
          maxLength={maxLength}
          style={{ minHeight: 100 }}
        />
        {lengthReachedMaximum ? (
          <span className={style.errorMessage}>
            {t("AKCIZNE_MARKICE.DOSTIGNUT_JE_MAKSIMALNI_BROJ_KARAKTERA")}
          </span>
        ) : (
          <></>
        )}
      </Flex>
    </Modal>
  );
};
